import React from 'react'
import _ from 'lodash'

const RootClass = 'ap-reservation-gantt'

const PrimaryHeaders = ({headers = [], onClick, style = {}}) => {
  return (
    <div style={{height: 38}} className="ap-reservation-gantt__date-row">
      {_.map(headers, (e, i) => (
        <div
          key={i}
          style={{flex: `0 0 ${e.width}px`, padding: '4px 8px', ...style}}
          className="ap-reservation-gantt__column-head"
          onClick={ev => onClick(ev, e)}
        >
          <span
            className={`${RootClass}__head-title ${
              e.current_day ? `${RootClass}__head-title--highlight` : ''
            }`}
          >
            {e.label}
          </span>
          <span
            className={`${RootClass}__head-title-sub ${
              e.current_day ? `${RootClass}__head-title-sub--highlight` : ''
            }`}
          >
            {e.label_sub}
          </span>
        </div>
      ))}
    </div>
  )
}

export default PrimaryHeaders
